export class AddProductSpendPeriodDto {
    timestampStart!: Date;
    timestampEnd!: Date;
    spendInCents: number;
    allocationPercentage: number;
}